import { collections } from "@/configs/firebase";
import Vue from "vue";
import moment from "moment";
import logger from "@/configs/logger";
import { firestoreAction } from "vuexfire";
import { ActionContext } from "@/types";
import { snakeCase } from "lodash";
import getCallConfig from "@/helpers/getCallConfig";
import { objectify } from "@/helpers";

async function getDispositions(context: ActionContext, taskAttribute: any) {
  try {
    const groups = context.state.user.groups || [];
    const dispositionGroup = getCallConfig(
      groups,
      objectify(taskAttribute).task_creation_source
    ).dispositions;

    let dispositions: any[] = [];

    if (dispositionGroup) {
      const snap = await collections.dispositionGroups
        .doc(dispositionGroup)
        .get();
      if (snap.exists) {
        const doc = snap.data();
        if (snap.exists && doc && Array.isArray(doc.dispositions)) {
          dispositions = await Promise.all(
            doc.dispositions.map(dispo =>
              collections.dispositions
                .doc(snakeCase(dispo))
                .get()
                .then(doc => doc.data())
            )
          );
        }
      } else {
        const snap = await collections.dispositions.get();
        dispositions = snap.docs.map(doc => doc.data());
      }
    } else {
      const snap = await collections.dispositions.get();
      dispositions = snap.docs.map(doc => doc.data());
    }
    return dispositions;
  } catch (err) {
    logger("error", "Fetch dispositions error", err);
  }
}

async function updateTaskAttribute(
  _context: ActionContext,
  payload: { data: any; taskAttributeId: string; notify: boolean }
) {
  try {
    const { taskAttributeId, data, notify } = payload;
    if (!taskAttributeId) {
      logger(
        "log",
        "skipping taskAttribute update, no taskAttribute id",
        payload
      );
    } else {
      await collections.taskAttribute.doc(taskAttributeId).update(data);
      if (notify) {
        Vue.toasted.success("Lead successfully updated").goAway(2000);
      }
    }
  } catch (err) {
    logger("error", "lead update error", err);
    Vue.toasted.error("Lead update error").goAway(2000);
  }
}

const unbindEnqueuedCalls = firestoreAction(({ unbindFirestoreRef }) => {
  return unbindFirestoreRef("enqueuedCalls");
});

const bindEnqueuedCalls = firestoreAction(({ bindFirestoreRef }: any) => {
  return bindFirestoreRef(
    "enqueuedCalls",
    collections.taskAttribute
      .where("reservation_status", "==", "enqueued")
      .where("task_sid_set", "==", true)
  );
});

export default {
  updateTaskAttribute,
  unbindEnqueuedCalls,
  bindEnqueuedCalls,
  getDispositions
};
